import type { Phase } from 'modules/Cube/domain/cube.domain.types'
import { atom } from 'jotai'

export type PhaseExpansion = {
  id: Phase['id']
  expanded: boolean
}

export const phaseExpansionAtom = atom<PhaseExpansion[]>([])
